import { SVGProps } from 'react'

type Props = {
  size?: number
  fill?: string
  stroke?: string
} & SVGProps<SVGSVGElement>

export const ChatIconLike = ({
  size = 20,
  fill = 'white',
  stroke = 'white',
  ...props
}: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.23518 18H13.9996C14.0269 18 14.0538 17.9974 14.0798 17.9919C14.7641 17.9636 15.3914 17.5891 15.7317 17C15.7413 16.9832 15.7496 16.9655 15.7568 16.9476C15.8301 16.7633 17.5589 12.4131 17.9043 11.1245C18.3039 9.63372 17.4158 8.09511 15.9238 7.69536C15.7048 7.63651 15.4746 7.60935 15.2011 7.60935L13.3282 7.602C13.5606 6.54086 13.5996 4.94897 13.5996 4.00002C13.5996 2.89705 12.7023 2 11.5996 2C10.4969 2 9.59962 2.89702 9.59962 4.00002V4.40028C9.59962 6.40833 8.11171 8.07519 6.18063 8.35745C6.21638 8.4217 6.23516 8.49401 6.23518 8.56754V18ZM3.59964 18H5.29403V8.56757C5.29403 8.50823 5.30633 8.45166 5.32814 8.39982H3.59964C2.71731 8.39982 1.99992 9.1177 1.99992 10V16.4C1.99992 17.2824 2.71728 18 3.59964 18Z"
        fill={fill}
        stroke={stroke}
      />
    </svg>
  )
}
